import vars from './_vars';

const $ = jQuery.noConflict();
// Helper functions:
import {throttle} from './functions/throttle';

// Plugins (NPM modules and uploaded files):
import Swiper, {Navigation, Pagination, Autoplay, Thumbs} from 'swiper/bundle'; // import Swiper bundle with all modules installed
// available Swiper.js modules = [Virtual, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar, Parallax, Zoom, Lazy, Controller, A11y, History, HashNavigation, Autoplay, Thumbs, FreeMode, Grid, Manipulation, EffectFade, EffectCube, EffectFlip, EffectCoverflow, EffectCreative, EffectCards]
import './vendors/jquery.nice-select.min.js'; // jQuery Nice Select
import {Fancybox} from "@fancyapps/ui"; // Fancybox

(function (s) {
	s.fn.isOnScreen = function (e) {
		var i = this.outerHeight(),
			t = this.outerWidth();
		if (!t || !i) return !1;
		var n = s(window),
			a = {
				top: n.scrollTop(),
				left: n.scrollLeft(),
			};
		(a.right = a.left + n.width()), (a.bottom = a.top + n.height());
		var o = this.offset();
		(o.right = o.left + t), (o.bottom = o.top + i);
		var r = {
			top: a.bottom - o.top,
			left: a.right - o.left,
			bottom: o.bottom - a.top,
			right: o.right - a.left,
		};
		return 'function' == typeof e
			? e.call(this, r)
			: 0 < r.top && 0 < r.left && 0 < r.right && 0 < r.bottom;
	};
})(jQuery);

$(document).ready(function () {
	"use strict";


	wrapVideoIframe();
	galleryStripSlider();
	services_module();
	services_module_slider();
	// timeline();
	specialties_slider();
	testimonials_slider();
	karrier_filter();
	features_module_slider();
	projekte_slider();
	mix_block_slider();
	select_file_js();
	searchAjaxFilter();

	/**
	 * Tweak for mobiles (full height)
	 */
	const fixFullheight = () => {
		const vh = window.innerHeight * 0.01;
		vars.htmlEl.style.setProperty('--vh', `${vh}px`);
	};

	fixFullheight();
	const fixHeight = throttle(fixFullheight);
	window.addEventListener('resize', fixHeight);


	/**
	 * Force load of all lazy-loading images
	 */
	setTimeout(function () {
		$('.lazyload.loading').removeClass('loading').addClass('loaded');
	}, 3000);


	/**
	 * Nice select
	 */
	// do not activate NiceSelect on those pages, where it might conflict with Select2
	if (!$('body').hasClass('woocommerce-account')) {
		$('select').niceSelect();
	}


	/**
	 * Trigger NiceSelect update after Woocommerce Update variations
	 */
	$(".variations_form").on("woocommerce_variation_has_changed", function () {
		$('.variations_form select').niceSelect('update');
	});


	/**
	 * Slider Images
	 */
	document.querySelectorAll('.swiper-images').forEach(slider => {
		const swiper = new Swiper(slider, {
			loop: true,
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			},
			pagination: {
				el: slider.querySelector('.swiper-pagination'),
				clickable: true,
			},
			navigation: {
				nextEl: slider.querySelector('.swiper-button-next'),
				prevEl: slider.querySelector('.swiper-button-prev'),
			},
			on: {
				// lazy load images
				slideChange: function () {
					try {
						lazyLoadInstance.update();
					} catch (e) {
					}
				}
			}
		});
	});

});

function wrapVideoIframe() {
	$('p iframe[src*="youtube.com"], p iframe[src*="vimeo.com"]').each(function () {
		// Wrap the iframe in a div with class "video-container"
		$(this).wrap('<div class="video-container"><div></div></div>');
	});
}


function galleryStripSlider() {
	// Assign some jquery elements we'll need
	var $swiper = $(".gallery_strip__slider");
	var $bottomSlide = null; // Slide whose content gets 'extracted' and placed
	// into a fixed position for animation purposes
	var $bottomSlideContent = null; // Slide content that gets passed between the
	// panning slide stack and the position 'behind'
	// the stack, needed for correct animation style

	// var mySwiper = new Swiper(".swiper-container-test", {
	// 	spaceBetween: 1,
	// 	slidesPerView: 2,
	// 	centeredSlides: true,
	// 	roundLengths: true,
	// 	loop: true,
	// 	loopAdditionalSlides: 30,
	// 	navigation: {
	// 		nextEl: ".swiper-button-next",
	// 		prevEl: ".swiper-button-prev"
	// 	}
	// });


	var swiper = new Swiper(".gallery_strip__slider", {
		spaceBetween: 1,
		slidesPerView: 2,
		centeredSlides: true,
		roundLengths: true,
		loop: true,
		loopAdditionalSlides: 30,
		spaceBetween: 24,

		// slidesPerView: "auto",
		// loop: true,
		// centeredSlides: true,
		// spaceBetween: 24,
		// autoplay: false,
		pagination: {
			el: ".gallery_strip__slider .swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: '.gallery_strip__slider .swiper-button-next',
			prevEl: '.gallery_strip__slider .swiper-button-prev',
		},
		breakpoints: {
			640: {
				spaceBetween: 30,
			},
			768: {
				// centeredSlides: true,
				spaceBetween: 50,
				// slidesPerView: 2,
			},
			1024: {
				spaceBetween: 80,
			},
		},
		on: {
			// lazy load images
			slideChange: function () {
				try {
					lazyLoadInstance.update();
				} catch (e) {
				}
			}
		}
	});
}

function services_module() {
	$('.services_module .hover_type .list_item').each(function () {
		var $this = $(this);
		var $this_number = $this.data('number');
		$this.on("mouseover", function () {
			$('.services_module .hover_type .list_item').removeClass('active');
			$this.addClass('active');
			$('.services_module .hover_type .list_item_content').removeClass('active');

			$('.services_module .hover_type .list_item_content[data-number="' + $this_number + '"]').addClass('active');
		});
	})
}

function services_module_slider() {

	/* Swiper
	**************************************************************/
	var swiper = Swiper;
	var init = false;


	/* Which media query
	**************************************************************/
	function swiperMode() {
		let mobile = window.matchMedia('(min-width: 0px) and (max-width: 767px)');
		// let tablet = window.matchMedia('(min-width: 769px) and (max-width: 1024px)');
		let desktop = window.matchMedia('(min-width: 768px)');

		if ($('.blog_post__slider').length) {
			// Enable (for mobile)
			if (mobile.matches) {
				if (!init) {
					init = true;
					swiper = new Swiper('.blog_post__slider', {
						slidesPerView: 1,
						autoplay: false,
						// autoplay: {
						// 	delay: 1000,
						// 	disableOnInteraction: false,
						// },
						loop: true,
						spaceBetween: 24,
						direction: 'horizontal',
						pagination: {
							el: ".swiper-pagination",
							// dynamicBullets: true,
							clickable: true,
						},

						breakpoints: {

							576: {
								slidesPerView: 2,
							},

						}

					});
				}
			}
			// Disable (for desktop)
			else if (desktop.matches) {
				swiper.destroy();
				init = false;
			}
		}
	}

	/* On Load
	**************************************************************/
	window.addEventListener('load', function () {
		swiperMode();
	});

	/* On Resize
	**************************************************************/
	window.addEventListener('resize', function () {
		swiperMode();
	});
}

function specialties_slider() {
	var swiper = new Swiper(".specialties_slider_nav", {
		loop: false,
		spaceBetween: 10,
		slidesPerView: "auto",
		freeMode: false,
		watchSlidesProgress: true,
	});
	var specialties_slider = new Swiper(".specialties_slider", {
		loop: true,
		spaceBetween: 10,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		thumbs: {
			swiper: swiper,
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
	});

}

function testimonials_slider() {
	new Swiper(".testimonials_slider", {
		loop: true,
		spaceBetween: 18,
		slidesPerView: 1,
		navigation: {
			nextEl: ".testimonials_slider .swiper-button-next",
			prevEl: ".testimonials_slider .swiper-button-prev",
		},
		pagination: {
			el: ".testimonials_slider .swiper-pagination",
			clickable: true,
		},
	});
}

function karrier_filter() {
	if ($('.karrier_list__filter').length) {
		$('.filter_el').change(function () {
			var filter = $('#filter');

			$.ajax({
				url: filter.attr('action'),
				data: filter.serialize(), // form data
				type: filter.attr('method'), // POST
				beforeSend: function (xhr) {
					console.log('before send ajax');
				},
				success: function (data) {
					$('#response').html(data); // insert data
				},
				error: function (xhr, ajaxOptions, thrownError) {
					console.log(xhr.status);
					console.log(thrownError);
				}
			});
			return false;
		});
	}
}

function features_module_slider() {

	/* Swiper
	**************************************************************/
	var swiper = Swiper;
	var init = false;


	/* Which media query
	**************************************************************/
	function swiperMode() {
		let mobile = window.matchMedia('(min-width: 0px) and (max-width: 1024px)');
		// let tablet = window.matchMedia('(min-width: 769px) and (max-width: 1024px)');
		let desktop = window.matchMedia('(min-width: 1025px)');
		if ($('.features_section__slider.mobile_slider').length) {
			// Enable (for mobile)
			if (mobile.matches) {
				if (!init) {
					init = true;
					var swiper = new Swiper('.features_section__slider.mobile_slider', {
						slidesPerView: 1,
						autoplay: false,
						// autoplay: {
						// 	delay: 1000,
						// 	disableOnInteraction: false,
						// },
						loop: true,
						spaceBetween: 24,
						direction: 'horizontal',
						pagination: {
							el: ".swiper-pagination",
							clickable: true,
						},

						breakpoints: {
							576: {
								slidesPerView: 2,
							},
						}

					});
				}
			}
			// Disable (for desktop)
			else if (desktop.matches) {
				swiper.destroy();
				init = false;
			}
		}
	}

	/* On Load
	**************************************************************/
	window.addEventListener('load', function () {
		swiperMode();
	});

	/* On Resize
	**************************************************************/
	window.addEventListener('resize', function () {
		swiperMode();
	});

	if ($('.features_section__slider.desktop_slider').length) {

		var swiper = new Swiper('.features_section__slider.desktop_slider', {
			slidesPerView: 1,
			autoplay: false,
			// autoplay: {
			// 	delay: 1000,
			// 	disableOnInteraction: false,
			// },
			loop: true,
			spaceBetween: 24,
			direction: 'horizontal',
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},

			breakpoints: {
				576: {
					slidesPerView: 2,
				},

				768: {
					slidesPerView: 3,
				},
			}

		});
	}
}

function projekte_slider() {
	var testimonials_slider = new Swiper(".projekte_slider", {
		loop: true,
		spaceBetween: 18,
		slidesPerView: 1,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		on: {
			// lazy load images
			slideChange: function () {
				try {
					lazyLoadInstance.update();
				} catch (e) {
				}
			}
		}
	});

}

function mix_block_slider() {
	var mix_block_slider = new Swiper(".image_slider_video_content .mix_block_slider", {
		loop: true,
		spaceBetween: 18,
		slidesPerView: 1,
		navigation: {
			nextEl: ".image_slider_video_content .swiper-button-next",
			prevEl: ".image_slider_video_content .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		on: {
			// lazy load images
			slideChange: function () {
				try {
					lazyLoadInstance.update();
				} catch (e) {
				}
			}
		}
	});

}

function formatBytes(bytes, decimals = 2) {
	if (!+bytes) return '0 Bytes';
	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

function select_file_js() {
	var $fileInput = $('.wpcf7-file');
	var $droparea = $('.label');

// highlight drag area
	$fileInput.on('dragenter focus click', function () {
		$droparea.addClass('is-active');
	});

// back to normal state
	$fileInput.on('dragleave blur drop', function () {
		$droparea.removeClass('is-active');
	});

// change inner text
	$fileInput.on('change', function () {
		var filesCount = $(this)[0].files.length;
		var $textContainer = $(this).prev();

		if (filesCount === 1) {
			// if single file is selected, show file name
			var fileName = $(this).val().split('\\').pop();
			$textContainer.text(fileName);
		} else {
			// otherwise show number of files
			$textContainer.text(filesCount + ' files selected');
		}
	});


	$('.wpcf7-file').each(function () {
		var $this = $(this);
		var file_name = $this.attr('name');
		$this.attr('id', file_name);
		$this.after('' +
			'<span class="label" for="' + file_name + '">' +
			'<span>' +
			'<span class="file_title">' +
			'<strong>' +
			`${wpApiSettings.select_file}` +
			'</strong> ' +
			`${wpApiSettings.drag_file}` +
			'</span>' +
			'<span class="file_subtitle visible-md-up">max. 10 MB (.docx, .pdf, .rtf, .txt, .jpg, .gif oder .zip.)</span>' +
			'</span>' +
			'</span>'
		);
		$this.parent().after('' +
			'<span class="file_subtitle hidden-md-up">max. 10 MB (.docx, .pdf, .rtf, .txt, .jpg, .gif oder .zip.)</span>' +
			'</span>'
		);

		var input = $(this);
		var label = input.next();
		var labelVal = label.html();

		input.on('change', function (e) {
			var fileName = '';
			fileName = e.target.value.split('\\').pop();
			var size = this.files[0].size;

			if (fileName) {
				input.addClass('active');
				label.addClass('active').find('span').html(
					'<span class="file_result">' +
					fileName +
					'</span>' +
					'<span class="file_result_size">' +
					formatBytes(size) +
					'</span>' +
					'<span class="reset">reset</span>'
				);
			} else {
				label.html(labelVal);
			}
		});

	});


	$(document).on("click", '.reset', function (event) {
		var $this = $(event.target);
		var input = $this.removeClass('active').closest('.wpcf7-form-control-wrap').find('.wpcf7-file');
		var label = input.next();
		label.removeClass('active');
		input.removeClass('active');

		var file_name = $this.attr('name');

		'<span class="label" for="' + file_name + '">' +
		label.html('' +
			'<span>' +
			'<span class="file_title">' +
			'<strong>' +
			`${wpApiSettings.select_file}` +
			'</strong> ' +
			`${wpApiSettings.drag_file}` +
			'</span>' +
			'<span class="file_subtitle">max. 10 MB (.docx, .pdf, .rtf, .txt, .jpg, .gif oder .zip.)</span>' +
			'</span>' +
			'</span>'
		);
	});

}

function searchAjaxFilter() {

		if ($('.search_results_filter').length) {
			$('.filter_el').change(function () {
				// $('#filter_curr_page').val(1);
				const filter = $('.search_results_filter');

				$.ajax({
					url: filter.attr('action'),
					data: filter.serialize(), // form data
					type: filter.attr('method'), // POST
					beforeSend: function (xhr) {
						console.log('before send ajax');
					},
					success: function (data) {
						$('.grid_results').html(data); // insert data
					},
					error: function (xhr, ajaxOptions, thrownError) {
						console.log(xhr.status);
						console.log(thrownError);
					}
				});
				return false;
			});
		}

	// $('.search_results_filter').submit(function() {
	// 	return false;
	// });
}
